import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';

export function GenericLanding() {
  return (
    <React.Fragment>
      {/* <CssBaseline /> */}
      <Container maxWidth="md" sx={{ mb: 4 }}>
        {/* <Paper
          variant="outlined"
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        > */}
        <Typography component="h1" variant="h4" align="center">
          Welcome
        </Typography>
        {/* </Paper> */}
      </Container>
    </React.Fragment>
  );
}
